export enum AuctionStatusEnum {
    Active = 1,
    Paused = 2,
    Cancelled = 4,
    Completed = 8,
    UserDisconnected = 16,
    Pending = 32,
    NotRegistered = 64,
}
